<template>
    <div class="checklist" style="max-width: 1000px; margin: 0 auto;">
        <div class="grid-x header">
            <div class="cell auto title">
                <h1>{{ title }}</h1>
            </div>
            <div class="cell shrink control">
                <img src="../assets/baseline-close-24px.svg" alt="" @click="$emit('close')">
            </div>
        </div>
        <p v-if="description && description.length > 0" class="description">
            {{ description }}
        </p>
        <div>
            <checklist-item
                v-for="(item, i) in list"
                :key="'item-' + i"
                :title="item.title"
                :state="item.state"
                :body="item.body"
                :opened="opened[i]"
                :index="i"
                @toggle="toggleTest(i)"
            />
        </div>
    </div>
</template>
<script>
import ChecklistItem from '@/components/ChecklistItem.vue'

export default {
    components: {
        ChecklistItem
    },
    props: {
        list: {
            type: Array,
            default: () => { [] }
        },
        title: {
            type: String,
            default: ''
        },
        description: {
            type: [String, undefined],
            default: undefined
        }
    },
    data() {
        return {
            opened: []
        }
    },
    mounted() {
        this.opened = this.list.map(() => false);
    },
    methods: {
        toggleTest(i) {
            console.log(this.opened[i]);
            this.opened.splice(i, 1, !this.opened[i]);
            console.log(this.opened[i]);
        }
    }
}
</script>